var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TextInput, useFocusWithin } from '@gravity-ui/uikit';
import { block } from '../../utils/cn';
import { useDateFieldProps } from './hooks/useDateFieldProps';
import { useDateFieldState } from './hooks/useDateFieldState';
import './DateField.css';
const b = block('date-field');
export function DateField(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    const state = useDateFieldState(props);
    const { inputProps } = useDateFieldProps(state, props);
    const [isActive, setActive] = React.useState(false);
    const { focusWithinProps } = useFocusWithin({
        onFocusWithinChange(isFocusWithin) {
            setActive(isFocusWithin);
        },
    });
    return (_jsx("div", Object.assign({ className: b(null, className), style: props.style }, focusWithinProps, { children: _jsx(TextInput, Object.assign({}, inputProps, { value: state.isEmpty && !isActive && props.placeholder ? '' : inputProps.value })) })));
}
